/**
 * Quem pode escolher outro colaborador no relatório de atividades.
 * Regra: perm_id === 1 OU usuário Ronaldo.
 */
export function isRonaldoUser(user) {
  if (!user) return false
  const email = String(user.pf_emailProf || user.mail || user.email || '').toLowerCase().trim()
  if (email === 'ronaldo.pla@ecossis.com.br') return true
  const name = String(
    user.displayName || user.name || user.pf_nomeExibicao || user.givenName || '',
  ).toLowerCase()
  return name.includes('ronaldo')
}

export function canSelectCollaborator(user) {
  if (!user) return false
  if (Number(user.perm_id) === 1) return true
  return isRonaldoUser(user)
}

export function userDisplayName(user) {
  if (!user) return 'Usuário'
  return (
    user.displayName
    || user.name
    || user.pf_nomeExibicao
    || `${user.givenName || ''} ${user.surname || ''}`.trim()
    || user.nome
    || 'Usuário'
  )
}

export function userGraphId(user) {
  if (!user) return null
  return user.pf_graphId || user.id || null
}
